import React from 'react'
import { DirectionsService,DirectionsRenderer} from '@react-google-maps/api';
import markerIcon from '../Assets/markerLogo.png'





function Directions({origin,destination,travelMode,setDirectionsData}) {
     const google = window.google
     const directionsService = new google.maps.DirectionsService()

     const [response,setResponse] = React.useState('');

     React.useEffect(()=>{
           if(origin !== '' && destination !== ''){
            directionsService.route({origin,destination,travelMode}, (response) => {
            if (response !== null) {
              if (response.status === 'OK') {
                setResponse(response)
                setDirectionsData({
                  distance:response.routes[0].legs[0].distance,
                  duration:response.routes[0].legs[0].duration,
                  start_location:response.routes[0].legs[0].start_location,
                  end_location:response.routes[0].legs[0].end_location

                })
                console.log(response)
              } else {
                console.log('response: ', response)
              }
            }
           })
           
           }
     },[origin,destination,travelMode])


 
   
   
    return (
   <div> 
    
<div>

{
  response !== null && (
    <DirectionsRenderer
      // required
      options={{
        directions: response,
        polylineOptions:{
          strokeColor:'#FFCC00',
          strokeWeight:8
        },
        suppressMarkers:true
      }}
      // optional
      onLoad={directionsRenderer => {
        console.log('DirectionsRenderer onLoad directionsRenderer: ', directionsRenderer)
      }}
      // optional
      onUnmount={directionsRenderer => {
        console.log('DirectionsRenderer onUnmount directionsRenderer: ', directionsRenderer)
      }}
    />
  )}

  </div>
  </div>
    )
}

export default Directions

